import React from 'react';
import { AppBootMask } from './boot/AppBootMask';
import type { BootPhase } from './boot/boot-phase';

export interface SplashScreenProps {
  /** Fase da mostrare; default `session` (rehydrate store / chunk di rotta). */
  phase?: BootPhase;
}

/**
 * Attesa dei gate applicativi (PersistGate, Suspense di rotta).
 *
 * @remarks
 * Non ha piu' una grafica propria: monta la maschera unica di avvio, cosi' il
 * passaggio da questa attesa alla successiva non produce nessuno stacco.
 */
export const SplashScreen: React.FC<SplashScreenProps> = ({
  phase = 'session',
}) => <AppBootMask phase={phase} withEscapeHatch />;
